@if (isUserLoggedIn()) {
  @defer (on immediate) {
    <div animate.enter="fade-in" animate.leave="fade-out" class="background non-selectable mesh-gradient" style="z-index: 1"></div>
  }
} @else {
  <div animate.enter="fade-in" animate.leave="fade-out" class="auth-background non-selectable">
    @defer (on idle) {
      @if (enableBackgroundVideo() && !videoError()) {
        <video
          animate.enter="fade-in"
          animate.leave="fade-out"
          #videoPlayer
          class="auth-background__video"
          preload="auto"
          autoplay
          loop
          muted
          playsinline
          (canplay)="onVideoCanPlay()"
          (error)="onVideoError()">
          <source [src]="videoSrc()" type="video/mp4" />
        </video>
      }
      @if (!enableBackgroundVideo() || videoError()) {
        <img
          animate.enter="fade-in"
          animate.leave="fade-out"
          class="auth-background__image"
          [ngSrc]="loginImage()"
          [alt]="'waytr-background' | translate"
          fill
          priority />
      }
    } @placeholder (minimum 200ms) {
      <img
        animate.enter="fade-in"
        animate.leave="fade-out"
        class="auth-background__image"
        [ngSrc]="loginImage()"
        [alt]="'waytr-background' | translate"
        fill
        priority />
    }
  </div>
}

@defer (on immediate) {
  <aside class="navigation" style="z-index: 10" animate.enter="fade-in" animate.leave="fade-out">
    <app-side-menu [sidebarCollapsed]="isSidebarCollapsed" />
  </aside>
}

@defer (on idle) {
  <div
    animate.enter="slide-in-up"
    animate.leave="slide-out-up"
    class="collapse-button"
    style="z-index: 500"
    [title]="isSidebarCollapsed ? ('open' | translate) : ('close' | translate) + ' sidebar'"
    tabindex="0"
    (click)="sidebarCollapsedClicked.set(!sidebarCollapsedClicked())"
    (keyup)="sidebarCollapsedClicked.set(!sidebarCollapsedClicked())">
    <waytr-icon width="1.2rem" height="1.2rem" name="chevron_left" class="collapse-button__icon clickable" />
  </div>
}

@defer (on immediate) {
  <main class="container" [class.highlight-active]="isHighlightActive()">
    <app-main />
  </main>
}

@defer (on idle) {
  <ng-template #installPromptNotification>
    <div class="install-notification">
      <h4>{{ 'install-prompt-title' | translate }}</h4>
      <p>{{ 'install-prompt-body' | translate }}</p>
      <button nz-button nzType="primary" class="button-accent" (click)="promptInstall()">{{ 'install-waytr' | translate }}</button>
      <button nz-button nzType="text" (click)="removeNotification()">{{ 'no-thanks' | translate }}</button>
    </div>
  </ng-template>
}

@defer (on idle) {
  @if (isHighlightActive()) {
    <div
      animate.enter="fade-in"
      animate.leave="fade-out"
      class="highlight-backdrop"
      [class.highlight-backdrop--active]="isHighlightActive()"></div>
  }
}

<!-- Cookie Consent Banner -->
@defer (on idle) {
  @if (shouldShowCookieBanner()) {
    <cookie-banner />
  }
}
